import React from "react";
import styled from "styled-components";
import { mobile } from "../Responsive";
import AboutProfile from "../images/AboutProfile.jpg";

// Css components

const AboutContainer = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  ${mobile({ flexDirection: "column", textAlign: "center", marginTop: "50px" })}
`;
const AboutLeft = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
  ${mobile({ width: "100%" })}
`;
const AboutCardBg = styled.div`
  width: 60%;
  height: 70vh;
  border-radius: 30px;
  position: absolute;
  top: 50px;
  left: 50px;
  background-color: #333;
  overflow: hidden;
  ${mobile({ height: "30vh", left: "60px", top: "60px" })}
`;
const AboutCard = styled.div`
  width: 60%;
  height: 70vh;
  border-radius: 30px;
  position: relative;
  overflow: hidden;
  ${mobile({ height: "30vh" })}
`;
const AboutImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 30px;
`;
const AboutRight = styled.div`
  flex: 1;
  ${mobile({ padding: "20px" })}
`;
const AboutTitle = styled.h1`
  font-weight: 400;
`;
const AboutSub = styled.p`
  margin: 20px 0px;
`;
const AboutDesc = styled.p`
  font-weight: 300;
`;

// Css components

const About = () => {
  return (
    <AboutContainer>
      <AboutLeft>
        <AboutCardBg></AboutCardBg>
        <AboutCard>
          <AboutImg src={AboutProfile} />
        </AboutCard>
      </AboutLeft>
      <AboutRight>
        <AboutTitle>About Me</AboutTitle>
        <AboutSub>
          "It is a long established fact that a reader will be distracted by the
          readable content. The same concept also applies into Programming."
        </AboutSub>
        <AboutDesc>
          I'm a <b>Full stack web developer</b>, Who wants to create cool stuff
          using code. I learned to code for fun but by the time it becomes my
          passion. And now I am learning new things and improving my skills
          everyday.
        </AboutDesc>
      </AboutRight>
    </AboutContainer>
  );
};

export default About;
